import { TimePlannerState } from './types';

export const timePlannerDefaultState: (
  data: Partial<TimePlannerState>,
) => TimePlannerState = ({
  openHourInSeconds,
  closeHourInSeconds,
  timeInterval,
}) => ({
  openHourInSeconds: openHourInSeconds || 0,
  closeHourInSeconds: closeHourInSeconds || 0,
  timeInterval: timeInterval || 0,
  day: {
    dayNumber: 0,
    total_planned: 0,
    staff_only_planned: 0,
    hours: [
      {
        hourNumber: 0,
        total_planned: 0,
        staff_only_planned: 0,
        intervals: [
          {
            total_planned: 0,
            staff_only_planned: 0,
            minute: 0,
          },
        ],
      },
    ],
  },
});
